<template lang="html">
  <component :is="layout">
    <LoadingDialog :value="loading" />
    <router-view />

    <!-- TODO: manage in DefaultLayout, or trigger from user store -->
    <ThePWAInstallBanner v-if="layout === 'User'" />
    <TheServiceWorkerUpdateSnackbar />
  </component>
</template>

<script>
import TheServiceWorkerUpdateSnackbar from '@/components/TheServiceWorkerUpdateSnackbar.vue';
import LoadingDialog from '@/components/LoadingDialog.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  metaInfo: {
    titleTemplate: title => {
      let prefix = process.env.VUE_APP_TITLE_PREFIX;
      return (
        (prefix ? `(${prefix}) ` : '') +
        (title ? `${title} - ` : '') +
        'CoreData'
      );
    },
  },
  components: {
    User: () => import(/* webpackChunkName: "user-layout" */'@/layouts/UserLayout.vue'),
    Basic: () => import(/* webpackChunkName: "basic-layout" */'@/layouts/BasicLayout.vue'),
    Device: () => import(/* webpackChunkName: "device-layout" */'@/layouts/DeviceLayout.vue'),
    Public: () => import(/* webpackChunkName: "public-layout" */'@/layouts/PublicLayout.vue'),
    ThePWAInstallBanner: () => import(/* webpackChunkName: "the-pwa-install-banner" */'@/components/ThePWAInstallBanner.vue'),
    TheServiceWorkerUpdateSnackbar,
    LoadingDialog,
  },
  computed: {
    ...mapGetters('app', [
      'currentRoute', 'currentRouteName',
    ]),
    ...mapGetters('user', [
      'currentUserLocale',
    ]),
    layout() {
      return this.$route.meta.layout || 'User';
    },
    loading() {
      return this.$store?.getters?.isLoading({ scope: 'global' });
    },
    activeLocale() {
      return this.currentUserLocale || localStorage.getItem('locale') || this.$i18n.locale || 'nl';
    },
  },
  watch: {
    $route(to, from){
      if (to.name == from.name) return;

      this.setPreviousRoute(from);
      this.setCurrentRoute(to);
    },
    activeLocale: {
      immediate: true,
      async handler(newLocale) {      
        if (!newLocale) return;

        const localeCode = newLocale === 'en-US' ? 'en' : newLocale;
        this.$locale(localeCode);
        this.$vuetify.lang.current = localeCode;
      },
    },
  },
  methods: {
    ...mapActions('app', [
      'setCurrentRoute', 'setPreviousRoute',
    ]),
  },
};
</script>

<style lang="css" scoped>
.messages-container {
  margin-left: auto;
  margin-right: auto;
  max-width: 900px;
}
</style>
<style lang="scss" src="@/styles/main.scss" />